export const InAppNotificationType = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
} as const;

export const DEFAULT_NOTIFICATION_DURATION_MS = 10000;

export type InAppNotificationType = (typeof InAppNotificationType)[keyof typeof InAppNotificationType];

export interface InAppNotification {
  readonly type: InAppNotificationType;
  readonly title?: string;
  readonly body?: string;
  readonly durationMs?: number | null;
  readonly onClick?: (notification: InAppNotification) => void;
  readonly bottomComponent?: React.ReactNode;
}
